module.exports = __webpack_public_path__ + "static/img/icon_preview.ccb3067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_preview.png
// module id = kI+9
// module chunks = 1